<template>
  <LayoutMinimal>
    <div
            id="finish_registration"
    >
      <section class="main">
        <div
                class="highlight-payment-box failable"
                :class="{failed: finishingUserPayments.error}"
        >
            <PaymentStatus
                    v-if="finishingUserPayments.highlightPayment"
                    :payment="finishingUserPayments.highlightPayment"
            />
            <div class="failed-wrapper">
                <p>
                    {{$t('error')}}
                </p>
                <button
                        type="button"
                        @click.prevent="loadFinishingUserPayments"
                >
                    {{$t('retry')}}
                </button>
            </div>
        </div>

        <div
            v-if="!claimsFailedCard"
            class="finish-box"
        >
          <div class="form loadable failable" :class="{loading: finishingUserData.loading, failed: finishingUserData.error}">
            <h1 class="title">
                {{$t('finish_registration.title')}}
            </h1>
            <template v-if="finishingUserData.loading || finishingUserData.error || finishingUserData.data">
                <RegisterForm
                        :finishing-user-data="finishingUserData.data"
                        :autologin="true"
                        @successfullRegister="successfullRegisterHandler"
                        @failedRegister="failedRegisterHandler"
                />
            </template>
            <template v-if="!finishingUserData.loading && !finishingUserData.error && !finishingUserData.data">
                <p>
                    {{$t('finish_registration.invalid_token.error')}}
                </p>
                <button type="button" class="btn login" @click.prevent="goToLogin">
                    {{$t('finish_registration.invalid_token.go_to_login')}}
                </button>
            </template>
            <div class="loader-wrapper">
              <Spinner/>
            </div>
            <div class="failed-wrapper">
                <p>{{$t('error')}}</p>
                <button
                        type="button"
                        @click.prevent="loadFinishingUserData"
                >
                    {{$t('retry')}}
                </button>
            </div>
          </div>
        </div>
      </section>
    </div>
    <template slot="after">
      <Footer/>
    </template>
  </LayoutMinimal>
</template>

<script>
    import Spinner from "../components/Spinner";
    import Footer from "../components/Footer";
    import LayoutMinimal from "../layouts/LayoutMinimal";
    import RegisterForm from "../components/RegisterForm";
    import resources from "../resources";
    import PaymentStatus from "../components/PaymentStatus";

    export default {
      components: {
          PaymentStatus,
          RegisterForm,
          LayoutMinimal,
          Spinner,
          Footer
      },
      data(){
        return {
            token: '',
            finishingUserData: {
                data: {
                    email: '',
                    finish_token: '',
                },
                loading: true,
                error: false,
            },
            finishingUserPayments: {
                highlightPayment: null,
                data: null,
                loading: false,
                error: false,
            },
            intervalLoadPayment: null
        }
      },
      methods:{
          loadFinishingUserData(){
              this.finishingUserData.error = false;
              this.finishingUserData.loading = true;
              this.finishingUserData.data = null;

              resources.unfinishedUsers.index({finish_token: this.token, limit: 1})
                  .then((unfinishedUsersData) => {
                      this.finishingUserData.data = unfinishedUsersData.data.data[0] || null;
                      this.finishingUserData.loading = false;
                  }).catch(() => {
                      this.finishingUserData.loading = false;
                      this.finishingUserData.error = true;
                  });
          },
          loadFinishingUserPayments(){
              this.finishingUserPayments.error = false;
              this.finishingUserPayments.loading = true;
              this.finishingUserPayments.payments = null;

              resources.payments.index({
                  user_finish_token: this.token,
                  order_by: ['created_at'],
                  include: ['user_credit_card']
              })
                  .then((payments) => {
                      this.finishingUserPayments.data = payments.data.data;
                      this.finishingUserPayments.loading = false;
                  }).catch((resp) => {
                      this.finishingUserPayments.loading = false;
                      this.finishingUserPayments.error = true;
                  });
          },
          successfullRegisterHandler(){
              if(this.$auth.user().membership_active){
                  this.$router.replace({name: 'home'});
              }else{
                  this.$router.replace({name: 'dashboard'});
              }
          },
          failedRegisterHandler(resp){

            //this.$router.replace({name: 'login'});
          },
          goToLogin(){
              this.$router.push({name: 'login'});
          }
      },
        
        computed: {
            claimsFailedCard(){
                return (
                    this.finishingUserPayments &&
                    this.finishingUserPayments.highlightPayment &&
                    (this.finishingUserPayments.highlightPayment.status === 'failed' || this.finishingUserPayments.highlightPayment.status === 'canceled') &&
                    this.finishingUserPayments.highlightPayment.data
                );
            },
        },
        
      watch: {
          'finishingUserPayments.data'(finishingUserPaymentsData){
              if(finishingUserPaymentsData){
                  if(this.$route.query.payment_id){
                      this.finishingUserPayments.highlightPayment = finishingUserPaymentsData.find(payment => payment.id == this.$route.query.payment_id) || null;
                  }else{
                      this.finishingUserPayments.highlightPayment = finishingUserPaymentsData[finishingUserPaymentsData.length - 1];
                  }
              }
          }
      },
      mounted(){
          this.token = this.$route.query.token;

          this.loadFinishingUserData();
          this.loadFinishingUserPayments();
    
          // si viene de ccbill => hago que revice el estado del pago
          // le meto un timeout por si el pago ya viene aprobado y no sea necesario revisar el pago
          let ccbillTimeout     = 3000;
          let ccbillIntervalTime= 5000;
    
          setTimeout(()=>{
              this.intervalLoadPayment = setInterval(()=> {
                  // console.log(this.finishingUserPayments.highlightPayment.status);
                  (this.finishingUserPayments && this.finishingUserPayments.highlightPayment && this.finishingUserPayments.highlightPayment.status === 'pending')
                      ? this.loadFinishingUserPayments()
                      : clearInterval(this.intervalLoadPayment);
              }, ccbillIntervalTime);
          },ccbillTimeout);
      },
        beforeDestroy() {
            clearInterval(this.intervalLoadPayment);
        }
    }
</script>

<style scoped lang="scss">
  @import '../styles/variables';
  @import '../styles/classes';

  #finish_registration {
    background-color: var(--pallete_dark_color);
    display: flex;
    color: var(--pallete_clear_text_color);
    flex-direction: column;
    justify-content: center;
    max-width: 750px;

    .highlight-payment-box{
        margin: 1em;
    }

    .btn.login{
        @extend %fresh-btn;
        display: block;
        width: 100%;
        padding: 1em;
    }

    section.main {
      justify-content: space-around;
      position: relative;
      margin: 0;

      .finish-box {
        display: flex;
        margin: 0 auto;
        padding: 1.5em;
        background-color: var(--background_01);
        border-radius: 10px;
        margin-left: 1em;
        margin-right: 1em;

        @media(max-width: 450px) {
          border-radius: 0;
          margin-left: 0;
          margin-right: 0;
          padding: .5em;
          width: 100vw;
        }

        .form {
          display: block;
          padding: 1em;
          border-radius: 5px;
          width: 100%;

          .title {
            text-align: center;
            width: 100%;
            text-transform: uppercase;
            letter-spacing: 0;
            margin: 0 0 .5em 0;
          }

          @media(max-width: 500px) {
            min-width: auto;
          }
        }
      }
    }

      .failed-wrapper{
          text-align: center;
          font-weight: bolder;
          padding-top: 1em;
      }
  }
</style>
